import React from 'react';
import { Github, ExternalLink } from 'lucide-react';
import AiAssistant from "../assets/images/ai-assistant.png";
import myFlix from "../assets/images/myFlix.png";
import Traffic from "../assets/images/traffic.png";
import ProjectPilot from "../assets/images/project-pilot-ss.png";
import myfinfolio from '../assets/images/MyFinFolio.png'
import eventMap from '../assets/images/event-map.png'
import devVisuals from '../assets/images/dev-visuals.png'
import StartupHub from '../assets/images/Startuphub.png'
import Tuner from '../assets/images/Tuner.png'
import Replio from '../assets/images/replio.png'
import ChatGPTProTools from '../assets/images/chatgptprotools.png'

const ProjectsPage = () => {
  
  const projects = [
    {
      id: "chatgptprotools",
      title: "ChatGPT Pro Tools",
      description: "A premium Chrome extension that enhances your AI chat experience (ChatGPT, Claude, Gemini) with powerful productivity features and beautiful themes.",
      longDescription: "ChatGPT Pro Tools is a premium Chrome extension designed to elevate your AI chat experience. It seamlessly integrates with ChatGPT, Claude, and Gemini, offering a suite of powerful productivity features and beautiful themes to enhance your workflow.",
      tags: ["Astro", "TailwindCSS"],
      imageUrls: [ChatGPTProTools],
      github: "https://github.com/bhimamalbhage/chatgpt-pro-tools",
      demo: "http://www.chatgptprotool.com/",
    },
    {
      id: "Replio",
      title: "Replio",
      description: "Replio is an intelligent email assistant application designed to streamline your email management using AI.",
      longDescription: "Replio is an AI-powered email assistant that helps you manage your inbox more efficiently. It suggests context-aware replies using AI, fetches and organizes your emails, and keeps your inbox manageable. Built with React and Tailwind CSS.",
      tags: ["Python", "React", "FastAPI"],
      imageUrls: [Replio],
      github: "https://github.com/bhimamalbhage/digital-twin",
      demo: "https://replio-eight.vercel.app/",
    },
    {
      id: "tuner",
      title: "Tuner",
      description: "Tuner democratizes advanced robotics by enabling anyone to fine-tune general-purpose robots for real-world tasks.",
      longDescription: "Tuner is an AI-powered platform that makes advanced robotics accessible to everyone. Users can define tasks in natural language, automatically match with pre-trained models from our marketplace, and fine-tune robots for custom use cases.",
      tags: ["Python", "React", "Typescript", "FastAPI"],
      imageUrls: [Tuner],
      github: "https://github.com/clemens-chr/tuner",
    },
    {
      id: "AI-powered-advisor",
      title: "University AI Advisor",
      description: "A custom AI-powered advisor designed to assist university students, faculty, and staff.",
      longDescription: "The Custom AI-powered Advisor for University Services is an intelligent virtual assistant designed to enhance the student and faculty experience by providing real-time guidance.",
      tags: ["Python", "React", "FastAPI", "RAG"],
      imageUrls: [AiAssistant],
      github: "https://github.com/bhimamalbhage/AI-Assistant-for-university",
    },
    {
      id: "traffic-data-collection",
      title: "Traffic Sense AI",
      description: "Scalable AI-powered traffic data sensing system leveraging computer vision to analyze real-time traffic patterns.",
      longDescription: "The Scalable Traffic Data Sensing System is an advanced AI-driven solution that utilizes computer vision to collect, process, and analyze real-time traffic data.",
      tags: ["Computer Vision", "Python", "OpenCV"],
      imageUrls: [Traffic],
      github: "https://github.com/bhimamalbhage/Traffic-Data-Collection",
      demo: "https://ieeexplore.ieee.org/document/10993978",
    },
    {
      id: "Eventify",
      title: "Eventify",
      description: "A web app that displays events based on user’s location, integrating multiple event APIs into an interactive map.",
      longDescription: "Eventify helps users discover live events happening near them. By integrating multiple event APIs, it fetches real-time event data and visualizes it on an interactive map. Features dynamic filtering options.",
      tags: ["React", "Python", "FastAPI"],
      imageUrls: [eventMap],
      github: "",
      demo: "https://eventify-map.vercel.app/",
    },
    {
      id: "startuphub",
      title: "StartupHub",
      description: "Discover recently funded startups and explore early-stage career opportunities at high-growth companies.",
      longDescription: "StartupHub is your go-to platform for tracking newly funded startups across all stages—from Pre-Seed to Series F. Discover emerging companies, explore their funding rounds, and find early hiring opportunities.",
      tags: ["Python", "React", "Typescript", "FastAPI"],
      imageUrls: [StartupHub],
      github: "https://github.com/bhimamalbhage/startuphub",
      demo: "https://startuphub-two.vercel.app/",
    },
     {
      id: "dev-visuals",
      title: "Dev Visuals",
      description: "An interactive web app that visualizes core programming concepts to help developers learn and revise quickly.",
      longDescription: "Dev Visuals is a web application built to simplify technical interview preparation by offering interactive and intuitive visualizations of fundamental programming concepts.",
      tags: ["React", "TailwindCSS"],
      imageUrls: [devVisuals],
      github: "https://github.com/bhimamalbhage/dev-visuals",
      demo: "https://dev-visuals.vercel.app/",
    },
     {
      id: "project-pilot",
      title: "ProjectPilot",
      description: "ProjectPilot is a powerful and intuitive project management application designed to streamline your email collaboration.",
      longDescription: "ProjectPilot is an advanced project management solution that enables teams to plan, execute, and monitor projects with ease. Designed for businesses, startups, and remote teams.",
      tags: ["React", "Javascript", "Tailwind CSS"],
      imageUrls: [ProjectPilot],
      github: "https://github.com/bhimamalbhage/Project-Management-Tool",
      demo: "https://project-pilot-bm.netlify.app/",
    },
     {
      id: "finance-dashboard",
      title: "Finance Dashboard",
      description: "Interactive dashboard for tracking financial metrics with customizable widgets and predictive analytics.",
      longDescription: "The Finance Dashboard provides a comprehensive view of financial performance with interactive charts, customizable widgets, and detailed reports. It features real-time data processing.",
      tags: ["React", "recharts"],
      imageUrls: [myfinfolio],
      github: "https://github.com/bhimamalbhage/myfinfolio",
      demo: "https://myfinfolio.vercel.app/",
    },
    {
      id: "my-flix",
      title: "MyFlix",
      description: "MyFlix is a modern movie discovery and management app inspired by Netflix.",
      longDescription: "MyFlix is an movie discovery and management application designed for cinephiles who want an easy and engaging way to explore and organize their movie preferences.",
      tags: ["React", "Node.js", "MongoDB", "Tailwind CSS"],
      imageUrls: [myFlix],
      github: "https://github.com/bhimamalbhage/myFlix-client",
      demo: "https://myflix-bhima.netlify.app/",
    }
  ];

  return (
    <div className="max-w-6xl mx-auto p-8 font-sans">
      <h1 className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-600 mb-2">
        Projects
      </h1>
      <p className="text-gray-500 mb-10">A collection of my best work and experiments.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {projects.map((project) => (
          <div 
            key={project.id} 
            className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col overflow-hidden"
          >
            <div className="h-56 bg-gray-100 relative overflow-hidden">
              <img 
                src={project.imageUrls[0]} 
                alt={project.title}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300"></div>
            </div>
            
            <div className="p-6 flex-1 flex flex-col">
              <div className="mb-3">
                <h2 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h2>
                <p className="text-gray-600 text-sm leading-relaxed">{project.description}</p>
              </div>
              
              <div className="flex flex-wrap gap-2 mb-4">
                {project.tags.slice(0, 3).map((tag, index) => (
                  <span key={index} className="px-2 py-1 bg-gray-50 text-gray-600 rounded text-xs font-medium border border-gray-100">
                    {tag}
                  </span>
                ))}
                {project.tags.length > 3 && (
                  <span className="px-2 py-1 bg-gray-50 text-gray-500 rounded text-xs font-medium border border-gray-100">
                    +{project.tags.length - 3}
                  </span>
                )}
              </div>

              <div className="mt-auto flex gap-3">
                {project.github && (
                  <a 
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="flex-1 px-4 py-2 bg-gray-900 text-white rounded-lg flex items-center justify-center gap-2 font-medium text-sm hover:bg-gray-800 transition-all shadow-sm"
                  >
                    <Github className="w-4 h-4" />
                    <span>Source</span>
                  </a>
                )}
                {project.demo && (
                  <a 
                    href={project.demo}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center justify-center gap-2 font-medium text-sm hover:bg-blue-700 transition-all shadow-sm"
                  >
                    <ExternalLink className="w-4 h-4" />
                    <span>Demo</span>
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsPage;